import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import PostAddIcon from "@mui/icons-material/PostAdd";
import Button from "../../components/Button";
import TableComponent from "../../components/TableComponent";
import { getPassConditions, deletePassConditionsById } from "../../api/passConditions";
import Confirm from "../../components/Confirm";

const PassCondition = ({ match, history }) => {
  const { t } = useTranslation();
  const [passConditions, setPassConditions] = useState(null);

  const [selectedOperationId, setSelectedOperationId] = useState(null);
  const [isDeleteModalShow, setIsDeleteModalShow] = useState(false);
  const [refresh, setRefresh] = useState(1);

  function showDeleteModal(id) {
    setSelectedOperationId(id);
    setIsDeleteModalShow(true);
  }

  async function confirmDeleteModal(isConfirmed) {
    if (isConfirmed) {
      await deletePassConditionsById(selectedOperationId);
    }
    setIsDeleteModalShow(false);
    setRefresh(refresh * -1);
  }

  useEffect(() => {
    (async () => {
      const res = await getPassConditions();

      setPassConditions(res);
    })();
  }, [refresh]);

  return (
    <>
      <Typography variant="h4">{t("pass_condition.title")}</Typography>
      {passConditions ? (
        <TableComponent
          TopComponent={
            <Button size="small" onClick={() => history.push(`/pass-conditions/add`)}>
              <PostAddIcon />
              {t("pass_condition.add_action")}
            </Button>
          }
          search={["name"]}
          header={[
            { title: t("id"), style: { width: "5%" } },
            { title: t("name") },
            { title: t("description") },
            { title: t("role.name") },
            { title: t("training.module") },
            { title: t("training.type") },
            { title: t("training.value") },
            { title: t("actions") },
          ]}
          items={passConditions}
          renderChildren={(passCondition) => (
            <TableRow key={passCondition.id}>
              <TableCell>{passCondition.id}</TableCell>
              <TableCell>{passCondition.name}</TableCell>
              <TableCell>{passCondition.description}</TableCell>
              <TableCell>{passCondition.role}</TableCell>
              <TableCell>{passCondition.module}</TableCell>
              <TableCell>{passCondition.type}</TableCell>
              <TableCell>{passCondition.value}</TableCell>

              <TableCell>
                <Button
                  icon={<EditIcon />}
                  onClick={() => history.push(`/pass-conditions/edit/${passCondition.id}`)}
                  title={t("pass_condition.edit_action")}
                />
                <Button
                  icon={<DeleteForeverIcon />}
                  onClick={() => showDeleteModal(passCondition.id)}
                  title={t("pass_condition.delete_action")}
                />
              </TableCell>
            </TableRow>
          )}
        />
      ) : null}

      {isDeleteModalShow && selectedOperationId ? (
        <Confirm title={t("pass_condition.delete_action")} onConfirm={confirmDeleteModal}>
          <p>{t("pass_condition.delete_confirm")}</p>
          <p>{t("pass_condition.delete_warning")}</p>
        </Confirm>
      ) : null}
    </>
  );
};

export default PassCondition;
